var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hall.details
    ? _c(
        "ApplicationWrapper",
        {
          attrs: {
            showTwoActionLines: this.showTwoActionLines,
            headerBackTooltip: _vm.fromMyBookings
              ? _vm.$t("overview.mybookings_header_backToBookingOverview")
              : _vm.$t("overview.details_header_backToHallOverview"),
            headerImage: _vm.hall.Image,
            headerTitle: _vm.hall.Title,
          },
          on: {
            "update:actionArea": _vm.handleActionAreaChanged,
            onButtonBackClick: _vm.handleButtonBackClick,
          },
        },
        [
          _c(
            "template",
            { slot: "details" },
            [
              _vm.needsImageSlider
                ? _c(
                    "v-carousel",
                    {
                      attrs: {
                        "hide-delimiter-background": "",
                        height: "auto",
                      },
                    },
                    _vm._l(
                      _vm.hall.details.Images,
                      function (hallImage, index) {
                        return _c(
                          "v-carousel-item",
                          { key: "hallImage_" + index },
                          [
                            _c("v-img", {
                              attrs: {
                                src: _vm.base64ImgPrefix + hallImage,
                                "max-height": "350px",
                                contain: "",
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  )
                : _vm._e(),
              _vm.needsImageSlider
                ? _c("v-divider", { staticClass: "my-4" })
                : _vm._e(),
              _c(
                "v-list",
                {
                  staticClass: "nomargin-firstchild nomargin-lastchild",
                  attrs: { "two-line": "" },
                },
                [
                  _vm.hall.booked && _vm.hall.BookedDates
                    ? _c(
                        "Detail",
                        {
                          attrs: {
                            appendIconTooltip: _vm.$t(
                              "overview.mybookings_cancelAllBookings"
                            ),
                            expandable: true,
                            prependIcon: "mdi-calendar",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "expansion-header" },
                            [
                              _c(
                                "v-row",
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "4" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "overview.mybookings_bookedMeetings",
                                              [_vm.hall.BookedDates.length]
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm.currentBreakpoint > 1
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "text--secondary",
                                          attrs: { cols: "8" },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { "no-gutters": "" },
                                            },
                                            [
                                              _c("v-spacer"),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "overview.label_nextMeeting",
                                                          [
                                                            _vm.getNextMeetingDateHall(
                                                              _vm.hall
                                                            ),
                                                          ]
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "template",
                            { slot: "expansion-content" },
                            _vm._l(
                              _vm.hall.BookedDates,
                              function (bookedDate, index) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key:
                                      "bookedMeeting_" +
                                      _vm.hall.Title +
                                      "_" +
                                      index,
                                    attrs: { "three-line": "", dense: "" },
                                  },
                                  [
                                    _vm.currentBreakpoint > 0
                                      ? _c(
                                          "v-list-item-avatar",
                                          [
                                            bookedDate.IsPayed
                                              ? _c(
                                                  "v-icon",
                                                  { attrs: { color: "green" } },
                                                  [_vm._v("mdi-currency-usd")]
                                                )
                                              : _c(
                                                  "v-icon",
                                                  {
                                                    attrs: { color: "orange" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "mdi-currency-usd-off"
                                                    ),
                                                  ]
                                                ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$d(
                                                  new Date(bookedDate.Date),
                                                  "longDate"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("v-list-item-subtitle", [
                                          !bookedDate.FullTime
                                            ? _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.getFancyTimestring(
                                                      bookedDate.From,
                                                      bookedDate.To,
                                                      true,
                                                      false
                                                    )
                                                  ),
                                                },
                                              })
                                            : _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.label_meetingWholeDay"
                                                    )
                                                  )
                                                ),
                                              ]),
                                        ]),
                                        _c(
                                          "v-list-item-subtitle",
                                          {
                                            staticStyle: {
                                              "text-wrap": "balance",
                                            },
                                          },
                                          [
                                            bookedDate.IsPayed
                                              ? _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "green--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "common.label_payed"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.label_noUnbookingPayedCourses"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ])
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass: "orange--text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.label_payment_outstanding"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-action",
                                      [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                disabled:
                                                                  bookedDate.IsPayed,
                                                                color: "error",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleBookClick(
                                                                      true,
                                                                      bookedDate.Id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              " mdi-cancel "
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "overview.details_content_cancelBooking"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "Detail",
                    {
                      attrs: {
                        expandable: true,
                        appendIcon: "mdi mdi-content-copy",
                        appendIconTooltip: _vm.$t(
                          "common.label_copyToClipboard"
                        ),
                        prependIcon: "mdi mdi-information-slab-box-outline",
                        title: _vm.$t("common.label_description"),
                      },
                      on: {
                        onActionIconClick: function ($event) {
                          _vm.copyToClipboard(
                            _vm.stripHtml(_vm.hall.details.Description)
                          )
                        },
                      },
                    },
                    [
                      _c("template", { slot: "expansion-content" }, [
                        _c("div", {
                          staticStyle: { "text-wrap": "balance" },
                          domProps: {
                            innerHTML: _vm._s(_vm.hall.details.Description),
                          },
                        }),
                      ]),
                    ],
                    2
                  ),
                  _c(
                    "Detail",
                    { attrs: { prependIcon: "mdi-map-marker" } },
                    [
                      _c(
                        "template",
                        { slot: "content-override" },
                        [
                          _c(
                            "v-list-item-content",
                            {
                              staticClass: "elevation-2 pa-2 rounded",
                              style: !_vm.hall.details.Street
                                ? "height: 72px"
                                : "",
                            },
                            [
                              _c("v-list-item-title", [
                                _vm._v(" " + _vm._s(_vm.hallStreet) + " "),
                              ]),
                              _c("v-list-item-subtitle", [
                                _vm._v(" " + _vm._s(_vm.hallZipCity) + " "),
                              ]),
                              !_vm.hall.details.Street
                                ? _c("v-list-item-subtitle", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          this.$t(
                                            "overview.details_content_clubAddress"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-action",
                            {
                              staticClass:
                                "align-center elevation-2 pa-2 ma-0 ml-4 rounded",
                              style: !_vm.hall.details.Street
                                ? "height: 72px"
                                : "",
                            },
                            [
                              _vm._t("actionarea", function () {
                                return [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: { icon: "" },
                                                        on: {
                                                          click:
                                                            _vm.handleOpenMapClick,
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        " mdi-map-marker-path "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2580594047
                                      ),
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "overview.details_content_showOnGMaps"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "Detail",
                    {
                      attrs: {
                        prependIcon: "mdi-clock-outline",
                        title: _vm.$t("overview.details_content_openingHours"),
                        expandable: true,
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "expansion-header" },
                        [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c("v-col", { attrs: { cols: "12", sm: "4" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "overview.details_content_openingHours"
                                      )
                                    )
                                ),
                              ]),
                              _vm.currentBreakpoint > 1
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text--secondary",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { "no-gutters": "" },
                                        },
                                        [
                                          _c("v-spacer"),
                                          !_vm.getTodaysOpeningHours().IsOpen
                                            ? _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "overview.details_content_openingHours_closedToday"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "overview.details_content_openingHours_openedToday"
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.getFancyTimestring(
                                                          _vm.getTodaysOpeningHours()
                                                            .From,
                                                          _vm.getTodaysOpeningHours()
                                                            .To,
                                                          true
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "expansion-content" },
                        _vm._l(
                          _vm.hall.details.OpeningHours,
                          function (weekDay, index) {
                            return _c(
                              "v-list-item",
                              {
                                key: "weekDay_" + _vm.hall.Title + "_" + index,
                                attrs: { dense: "" },
                              },
                              [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "weekdays.day_" + weekDay.Day
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("v-list-item-subtitle", [
                                      weekDay.IsOpen
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getFancyTimestring(
                                                  weekDay.From,
                                                  weekDay.To,
                                                  true
                                                )
                                              ),
                                            },
                                          })
                                        : _c(
                                            "div",
                                            { staticClass: "red--text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "overview.details_content_openingHours_closed"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "Detail",
                    { attrs: { prependIcon: "mdi-wallet", expandable: true } },
                    [
                      _c(
                        "template",
                        { slot: "expansion-header" },
                        [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "" } },
                            [
                              _c("v-col", { attrs: { cols: "12", sm: "4" } }, [
                                _vm.hall.details.Rent.PerDay
                                  ? _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "overview.details_content_rentPerDay"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.hall.details.Rent.PerHour
                                  ? _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "overview.details_content_rentPerHour"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm.currentBreakpoint > 1
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text--secondary",
                                      attrs: { cols: "8" },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { "no-gutters": "" },
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _vm.hall.details.Rent.Amount > 0.0
                                                ? _c("div", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "overview.details_content_rentToday"
                                                          )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$n(
                                                            _vm.getTodaysRent(),
                                                            "currency",
                                                            "de-DE"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ])
                                                : _c("div", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "overview.details_content_rentToday"
                                                          )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "common.label_free"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "expansion-content" },
                        [
                          _c(
                            "v-list-item",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "overview.details_content_regularPrice"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("v-list-item-subtitle", [
                                    _vm.hall.details.Rent.Amount > 0.0
                                      ? _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$n(
                                                _vm.hall.details.Rent.Amount,
                                                "currency",
                                                "de-DE"
                                              )
                                            )
                                          ),
                                        ])
                                      : _c("div", [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.label_free"))
                                          ),
                                        ]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._l(
                            _vm.hall.details.SpecialRents,
                            function (specialRent, index) {
                              return _c(
                                "v-list-item",
                                { key: index, attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.getFullDayName(
                                                specialRent.Days
                                              ) + "s"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c("v-list-item-subtitle", [
                                        specialRent.Amount > 0.0
                                          ? _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$n(
                                                    specialRent.Amount,
                                                    "currency",
                                                    "de-DE"
                                                  )
                                                )
                                              ),
                                            ])
                                          : _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("common.label_free")
                                                )
                                              ),
                                            ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    2
                  ),
                  _vm.hall.tags.length > 0
                    ? _c(
                        "Detail",
                        { attrs: { prependIcon: "mdi-weight-lifter" } },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c("v-list-item-title", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "overview.details_content_typesOfUse"
                                      )
                                    )
                                ),
                              ]),
                              _c(
                                "v-list-item-subtitle",
                                [
                                  _c(
                                    "v-slide-group",
                                    {
                                      staticClass: "pa-0",
                                      attrs: {
                                        "show-arrows": "",
                                        id: "tagslide",
                                      },
                                    },
                                    _vm._l(
                                      _vm.hall.tags,
                                      function (tag, index) {
                                        return _c("Tag", {
                                          key:
                                            "tag_hallDetail" +
                                            _vm.hall.Id +
                                            "_" +
                                            index,
                                          attrs: {
                                            tagCount: _vm.hall.tags.length,
                                            tagInfo: tag,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.SessionData.member.permissions.HallenSchreiben
            ? _c(
                "template",
                { slot: "actionbuttons" },
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "center", "no-gutters": "" } },
                    [
                      _vm.canRemoveBooking
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              style: _vm.showTwoActionLines ? "width: 95%" : "",
                              attrs: { loading: _vm.isBooking, color: "error" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleBookClick(true)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "overview.details_action_removeBooking"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.hall.booked
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              style: _vm.showTwoActionLines ? "width: 95%" : "",
                              attrs: {
                                loading: _vm.isBooking,
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleBookClick(false)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "overview.details_action_addAnotherHallBooking"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              style: _vm.showTwoActionLines ? "width: 95%" : "",
                              attrs: {
                                loading: _vm.isBooking,
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleBookClick(false)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "overview.details_action_addHallBooking"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("template", { slot: "actionbuttons" }, [
                _c("p", {
                  staticClass: "text-center ma-0",
                  staticStyle: {
                    "align-self": "center",
                    "text-wrap": "balance",
                  },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("common.label_noBookingPermsHall")
                    ),
                  },
                }),
              ]),
        ],
        2
      )
    : _c(
        "v-container",
        { staticStyle: { height: "400px" } },
        [
          _c(
            "v-row",
            {
              staticClass: "fill-height",
              attrs: { "align-content": "center", justify: "center" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-subtitle-1 text-center",
                  attrs: { cols: "12" },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("overview.loading_hallDetails")) + " "
                  ),
                ]
              ),
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c("v-progress-linear", {
                    attrs: {
                      color: "primary",
                      indeterminate: "",
                      rounded: "",
                      height: "6",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }